import React, { useEffect, useState } from "react";
import AppLayout from "../../core/layouts/AppLayout";
import "../../styles/listing.scss";

import Moment from "react-moment";
import moment from "moment";
import {
  ListTable,
  ListTableColumn,
  ListHeader,
  Dict,
  FilterValueType,
  getFilters,
  PaginatedApiResponse,
  ListSort,
  SortOrder,
  Showroom,
  QueryFilter,
  ListFilters,
  ListHeaderSearch,
  MultiSelectFilter,
  ListColumnSettings,
  SavedFilter,
  ListEntityType,
  Column,
  useLead,
  useConfiguration,
  SingleSelectFilter,
  useHasPermission,
  AppPermissions,
  City,
  CityLocation,
  CityZone,
} from "../../core";
import { State } from "../../core/store/interfaces";
import { useMasterData } from "../../core/hooks/useMasterData";
import api from "../../api";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import { ContainerLoader } from "../../components/loader";
import { useHistory, useLocation } from "react-router-dom";
import queryString, { ParsedQuery } from "query-string";

import DateRangeListFilter, {
  IDateRange,
} from "../../core/components/list-filters/DateRangeListFilter";
import Pagination from "../../core/components/pagination/Pagination";
import { toastr } from "react-redux-toastr";
import { Grade, LeadRequirement } from "../../core/api/models/requirement";
import { useSelector } from "react-redux";
import { decodeHtmlEntities } from "../../utils/common";
import { RouteKeys } from "../routes/route-keys";
import RequirementPropertyDetailPage from "../requirement/components/RequirementPropertyDetail";
import { Unit } from "../../core/api/models/project";
import { Property } from "../../core/api/models/property";
import DateRangeListFilterWithCustomButton from "../../core/components/list-filters/DateRangeListFilterWithCustomButton";

export interface Project {
  _id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  projectID: number;
  projectName: string;
  projectBuilderName: string;
  propertyTypeName: string;
  propertyTypeKey: string;
  projectAddress1: string;
  projectAddress2?: string;
  projectCurrentStatus: string;
  checkRental?: string;
  projectTypeID: number;
  totalBuiltupArea: string;
  propertyUnitSqftRange?: string;
  projectDescription: string;
  propertyUnitBedRooms?: string;
  propertyUnitPriceRange?: string;
  propertyUnitPriceRangeMap?: string;
  propertyFeatured?: string;
  propertyKey?: string;
  projectKey: string;
  propertyPurpose?: string;
  cityID: number;
  city: City;
  cityLocationID: number;
  cityLocation: CityLocation;
  cityLocName: string;
  propertyCurrentStatus?: string;
  propertyAddedDate?: string;
  propertyUpdateDate?: string;
  projectAddedDate?: string;
  projectAddedAt?: Date;
  allPropertyAttributes?: any;
  propertyDescription?: string;
  furnishingStatus?: string;
  propertyTypeID?: string;
  isNegotiable?: string;
  priceOnReq?: string;
  proLatitude?: string;
  proLongitude?: string;
  possessionDate?: string;
  projectPossessionDate?: string;
  isOffer?: string;
  propertyOfferStartTime?: string;
  propertyOfferEndTime?: string;
  propertyOfferDiscount?: string;
  propertySoldOutStatus?: string;
  propertySoldOutPrice?: string;
  propertySoldOutDate?: string;
  openhouseStatus?: string;
  propertyPrice?: string;
  propertyPriceMap?: string;
  currencySymbolLeft?: string;
  currencySymbolRight?: string;
  projectUserCompanyName?: string;
  projectUserCompanyLogo?: string;
  propertyFavourite?: string;
  projectFavourite?: string;
  projectCoverImage?: string;
  propertyCoverImage?: string;
  propertyBedRoom?: string;
  propertySqrFeet?: string;
  propertyPlotArea?: string;
  planPropertyDetails?: string;
  planEnquiry?: string;
  planEnquiryCount?: string;
  planEnquiryCountBalance?: string;
  userTypeID?: number;
  userID?: number;
  type?: string;
  properyPriceType?: string;
  numberOfSeats?: number;
  publicDisplay?: string;
  currencyID_6?: number;
  propertyPrices?: any;
  pricesPerSqfts?: any;
  pricePerSqft?: number;
  rawPricePerSqft?: string;
  rentUnitCount?: number;
  sellUnitCount?: number;
  link?: string;
  uniqueArray?: string[];
  propertyUnitIDs?: string;
  amenities?: any[];
  unitDetails?: Unit[];
  companyId: string;
  projectId: string;
  attributes?: any[];
  resImages?: any[];
  totalBuiltUpAreaSqFt?: number;
  rawTotalBuiltUpAreaSqFt?: string;
  noOfFloors?: string;
  perFloorAreaSqFt?: string;
  occupancyCertificate?: string;
  fireNoc?: string;
  projectTypeName?: string;
  countryName?: string;
  stateName?: string;
  zipCode?: string;
  projectLatitude?: number;
  projectLongitude?: number;
  projectOffer?: string;
  projectStatus?: string;
  projectMaxPrice?: string;
  projectBannerImage?: string;
  projectMinPrice?: string;
  projectFloorImage?: string;
  imagePath?: string;
  document?: string[];
  secondaryLocality?: string[];
  projImageCat?: any[];
  cityZone?: CityZone;
  projectTypeDetails?: any;
  properties?: Property[];
  tenantDetails?: any;
  grade?: Grade;
  projectFeatured?: any;
  propertyPurposes?: string[];
  propertyTypeKeys?: string[];
  interiorTypes?: string[];
  propertyDetails?: any[];
}

const TenancyExpiryList: React.FunctionComponent = () => {
  const history = useHistory();
  const params = useLocation().search;
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState<Dict<FilterValueType>>({});
  const canViewProject = useHasPermission(AppPermissions.ViewProject);
  const [detailModal, setDetailModal] = React.useState<{
    isOpen?: boolean;
    id?: string;
    // type?: string;
  }>({});

const columnList = [
  <ListTableColumn
    label="Lease Start Date"
    source="tenantStartDate"
    column="tenantStartDate"
    showDefault
    formatContent={(d: string | Date | moment.Moment) =>
      moment(d).format("DD MMM YYYY")
    }
    sortable
    settingsGroup="Lease Start Date"
  ></ListTableColumn>,
  <ListTableColumn
    label="Lease End Date"
    source="tenantEndDate"
    column="tenantEndDate"
    formatContent={(d: string | Date | moment.Moment) =>
      moment(d).format("DD MMM YYYY")
    }
    showDefault
    sortable
    settingsGroup="Lease End Date"
  ></ListTableColumn>,
  <ListTableColumn
    label="Lock Expiry Date"
    source="lockinPeriodEndDate"
    column="lockinPeriodEndDate"
    formatContent={(d: string | Date | moment.Moment) =>
      moment(d).format("DD MMM YYYY")
    }
    showDefault
    sortable
    settingsGroup="Lock Expiry Date"
  ></ListTableColumn>,
  <ListTableColumn
    label="Status"
    source="tenancyStatus"
    column="tenancyStatus"
    showDefault
    formatContent={(tenancyStatus: number )=>tenancyStatus=== 1 ? 'Verified' : 'Unverified'}
    sortable
    settingsGroup="Status"
  ></ListTableColumn>,
  <ListTableColumn
    label="Tenant Name"
    source="tenantsName"
    column="tenantsName"
    showDefault
    sortable
    settingsGroup="Tenant Name"
  ></ListTableColumn>,
  <ListTableColumn
    label="Phone"
    source="primaryPhone"
    column="primaryPhone"
    showDefault
    sortable
    settingsGroup="phone"
  ></ListTableColumn>,
  <ListTableColumn
    label="Leased Floors"
    source="floorunitNames"
    formatContent={(floorunitNames)=><div style={{
      width: '375px',
      wordBreak: 'break-all',
      whiteSpace: 'normal'
    }}>{floorunitNames.join(', ')}</div>}
    column="floorunitNames"
    showDefault
    sortable
    settingsGroup="Leased Floors"
  ></ListTableColumn>,
  <ListTableColumn
    label="Actions"
    source="action"
    column="action"
    showDefault
    formatContent={(action)=><div>
      <div role="button" className="text-decoration-underline mb-1" onClick={() => setDetailModal({
        isOpen: true,
        id: action.projectId
        })}>Project Page</div>
      <div role="button" className="text-decoration-underline"onClick={()=> history.push(`${RouteKeys.Company360View}/${action.companyId}?tab=occupancy-info`)} >Tenancy Page</div>
    </div>}
    sortable
    settingsGroup="Actions"
  ></ListTableColumn>,
];

  const { data: leadSettings, reload: reloadSettings } = useDataLoader<{
    filters: SavedFilter[];
    columnSettings?: ListColumnSettings;
  }>(() => api.settings.getListColumnSettings(ListEntityType.TenancyExpiryTracker));

  // useEffect(() => {
  //   const handleFilterOptionsApi = async () => {
  //     try {
  //       const propertyTypeData = await api.AddNewRequirement.getPropertyType();
  //       const subTypes = propertyTypeData.reduce((acc: any, item: any) => {
  //         acc.push(
  //           ...item.subTypes.map(
  //             (subType: { _id: any; propertyTypeName: any }) => ({
  //               value: subType._id,
  //               name: decodeHtmlEntities(subType.propertyTypeName),
  //             })
  //           )
  //         );
  //         return acc;
  //       }, []);
  //       setPropertyType(subTypes);
  //     } catch (error) {
  //       // console.log("Failed to fetch property type data:", error);
  //     }

  //     try {
  //       const transactionExecutiveData = await api.user.getCrmAgents({
  //         sortBy: "name",
  //         sortOrder: SortOrder.ASC,
  //       })

  //       const transactionExecutiveOptions = transactionExecutiveData?.map((item: any) => ({
  //         value: item._id,
  //         name: decodeHtmlEntities(item?.name),
  //       }));
  //       setTransactionExecutive(transactionExecutiveOptions)
  //     } catch (error) {
  //       // console.log("Failed to fetch property type data:", error);
  //     }
  //     try {
  //       const userListData = await api.user.getUserList();
  //       const userListDataOptions = userListData?.map((item: any) => ({
  //         value: item._id,
  //         name: decodeHtmlEntities(item?.name),
  //       }));
  //       setUserList(userListDataOptions)
  //     } catch (error) {
  //       // console.log("Failed to fetch property type data:", error);
  //     }
  //   };

  //   handleFilterOptionsApi()
  // }, [])

  const {
    performAction: saveFilter,
    isPerforming: savingFilter,
  } = usePerformAction(
    (fls: Dict<FilterValueType>, name: string) =>
      api.settings.saveFilter(fls, name, ListEntityType.TenancyExpiryTracker),
    () => {
      toastr.success("Success", "Filter Saved");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to save filter");
    }
  );

  const { performAction: removeFilter } = usePerformAction(
    (_id: string) => api.settings.removeSavedFilter(_id),
    () => {
      toastr.success("Success", "Filter Removed");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to remove filter");
    }
  );

  const { performAction: saveColumnSettings } = usePerformAction(
    (cols: Column[]) =>
      api.settings.saveListColumnSettings(cols, ListEntityType.TenancyExpiryTracker),
    reloadSettings
  );

  const loadFromQuery = () => {
    const queryFilter: QueryFilter = {};
    const queries: ParsedQuery<string> = queryString.parse(params);
    queryFilter.query = queries.query as string;
    if (queries.filters) {
      queryFilter.filters = JSON.parse(queries.filters?.toString());
    }
    if (queries.page) {
      queryFilter.page = Number(queries.page || 1);
    }
    if (queries.perPage) {
      queryFilter.perPage = Number(queries.perPage || 1);
    }
    if (queries.startDate) {
      queryFilter.startDate = moment(queries.startDate as string).toDate();
    }
    if (queries.endDate) {
      queryFilter.endDate = moment(queries.endDate as string).toDate();
    }

    if (queries.sort) {
      queryFilter.sort = JSON.parse(queries.sort?.toString());
    }

    if (queries.listView) {
      queryFilter.listView = queries.listView?.toString();
    }

    return queryFilter;
  };


  const [tenancyLeaseExpiryTracker, setTenancyLeaseExpiryTracker] = useState<IDateRange | undefined>({
    startDate: loadFromQuery()?.startDate,
    endDate: loadFromQuery()?.endDate,
  });
  const [tenancyLockExpiryTracker, setTenancyLockExpiryTracker] = useState<IDateRange | undefined>({
    startDate: loadFromQuery()?.startDate,
    endDate: loadFromQuery()?.endDate,
  });

  const [sort, setSort] = useState<ListSort>({
    sortBy: loadFromQuery()?.sort?.sortBy,
    sortOrder: loadFromQuery()?.sort?.sortOrder,
  });

  const [page, setPage] = React.useState(loadFromQuery()?.page || 1);
  const [perPage, setPerPage] = React.useState(loadFromQuery()?.perPage || 20);

  const { data, loading, loaded, reload } = useDataLoader<
    PaginatedApiResponse<Project> & { lastUpdatedAt: Date }
  >(
    (
      searchTerm: string | undefined,
      searchFilters: Dict<FilterValueType>,
      currentPage: number,
      pageCount: number,
      searchOrder?: ListSort,
      tenancyLeaseExpiryTrackerData?: IDateRange,
      tenancyLockExpiryTrackerData?: IDateRange
    ) => {

      return api.tenancy.getTenancyHistoryExpiredList({
        ...getFilters(loadFromQuery()?.filters || filters),
        tenancyLeaseFromExpiryDate: tenancyLeaseExpiryTrackerData?.startDate
          ? moment(tenancyLeaseExpiryTrackerData?.startDate).startOf("day").toDate()
          : undefined,
          tenancyLeaseToExpiryDate: tenancyLeaseExpiryTrackerData?.endDate
          ? moment(tenancyLeaseExpiryTrackerData?.endDate).endOf("day").toDate()
          : undefined,
          tenancyLockFromExpiryDate: tenancyLockExpiryTrackerData?.startDate
          ? moment(tenancyLockExpiryTrackerData?.startDate).startOf("day").toDate()
          : undefined,
          tenancyLockToExpiryDate: tenancyLockExpiryTrackerData?.endDate
          ? moment(tenancyLockExpiryTrackerData?.endDate).endOf("day").toDate()
          : undefined,
        page: currentPage,
        tenantsName: (loadFromQuery()?.query || searchTerm)  ? loadFromQuery()?.query || searchTerm : undefined,
        sortBy: searchOrder?.sortBy,
        sortOrder: searchOrder?.sortOrder,
        perPage: pageCount,
      });
    },
    [search, filters, page, perPage, sort, tenancyLeaseExpiryTracker, tenancyLockExpiryTracker]
  );

  useEffect(() => {
    if (loaded) {
      setPage(1);
      onChangeFilter(filters, search, 1, perPage, tenancyLeaseExpiryTracker,tenancyLockExpiryTracker,  sort);
      reload(search, filters, 1, perPage, sort, tenancyLeaseExpiryTracker, tenancyLockExpiryTracker);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filters, sort, perPage, tenancyLeaseExpiryTracker, tenancyLockExpiryTracker]);

  useEffect(() => {
    if (loaded) {
      reload(search, filters, page, perPage, sort, tenancyLeaseExpiryTracker, tenancyLockExpiryTracker);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  React.useEffect(() => {
    const filterResonse = loadFromQuery();

    if (filterResonse.query) {
      setSearch(filterResonse.query as string);
    }

    if (filterResonse.filters) {
      if (
        filterResonse.filters?.autolineStatus &&
        Array.isArray(filterResonse.filters.autolineStatus)
      ) {
        filterResonse.filters.autolineStatus = filterResonse.filters.autolineStatus?.filter(
          (x: any) => x.value !== "PreVin" && x.value !== "Produced"
        );
        if (!filterResonse.filters.autolineStatus?.length) {
          delete filterResonse.filters.autolineStatus;
        }
      }
      setFilters(filterResonse.filters);
    }

    if (filterResonse.page) {
      setPage(filterResonse.page);
    }
    if (filterResonse.perPage) {
      setPerPage(filterResonse.perPage);
    }
  }, []);

  const [selected, setSelected] = useState<string[]>([]);

  const onSaveFilter = (name: string) => {
    saveFilter(filters, name);
  };

  const onRemoveFilter = (_id: string) => {
    removeFilter(_id);
  };

  const onChangeFilter = (
    searchFilters: Dict<FilterValueType>,
    searchValue: string,
    currentPage: number,
    numberOfPages: number,
    tenancyLeaseExpiryTrackerData?: IDateRange,
    tenancyLockExpiryTrackerData?: IDateRange,
    sortOption?: ListSort
  ) => {
    let query = `query=${encodeURIComponent(
      searchValue
    )}&page=${currentPage}&perPage=${numberOfPages}`;

    if (
      getFilters(searchFilters) &&
      Object.keys(getFilters(searchFilters)).length
    ) {
      query =
        query + `&filters=` + encodeURIComponent(JSON.stringify(searchFilters));
    }
    if (tenancyLeaseExpiryTrackerData?.startDate) {
      query =
        query + `&tenancyLeaseExpiryTrackerStartDate=` + moment(tenancyLeaseExpiryTrackerData?.startDate).format("DD-MMM-YYYY");
    }
    if (tenancyLeaseExpiryTrackerData?.endDate) {
      query =
        query + `&tenancyLeaseExpiryTrackerEndDate=` + moment(tenancyLeaseExpiryTrackerData?.endDate).format("DD-MMM-YYYY");
    }
    if (tenancyLockExpiryTrackerData?.startDate) {
      query =
        query + `&tenancyLockExpiryTrackerStartDate=` + moment(tenancyLockExpiryTrackerData?.startDate).format("DD-MMM-YYYY");
    }
    if (tenancyLockExpiryTrackerData?.endDate) {
      query =
        query + `&tenancyLockExpiryTrackerEndDate=` + moment(tenancyLockExpiryTrackerData?.endDate).format("DD-MMM-YYYY");
    }
    if (sortOption && sortOption.sortBy) {
      query = query + `&sort=` + JSON.stringify(sortOption);
    }
    history.replace(`/tenancy-expiry-tracker?${query}`);
  };

  const filterRow = (
    <ListFilters
      key="filter-row"
      savedFilters={leadSettings?.filters || []}
      onSaveFilter={onSaveFilter}
      isSavingFilter={savingFilter}
      onRemoveFilter={onRemoveFilter}
      filters={filters}
      onFilter={(searchFilters: Dict<FilterValueType>) => {
        onChangeFilter(searchFilters, search, page, perPage, tenancyLeaseExpiryTracker,tenancyLockExpiryTracker,  sort);
        setFilters(searchFilters);
      }}
    >
      <SingleSelectFilter
        label="Status"
        filterKey="status"
        key="status"
        allowSearch
        options={[
          {
            name:"Verified",
            value:1
          },
          {
            name:"Unverified",
            value:0
          },
        ]}
          valueField="value"
          labelField="name"
      />
    </ListFilters>
  );

  const headerActions = [
    <ListHeaderSearch
      placeholder="Tenant name"
      serachTerm={search}
      onSearch={(val: string) => {
        onChangeFilter(filters, val, page, perPage, tenancyLeaseExpiryTracker,tenancyLockExpiryTracker,  sort);
        setSearch(val);
      }}
    />,
    <DateRangeListFilterWithCustomButton
    placeholder={'Select lease expiry date'}
    default={tenancyLeaseExpiryTracker}
    onChange={(d?: IDateRange) => {
      setTenancyLeaseExpiryTracker({
        startDate: d?.startDate,
        endDate: d?.endDate,
      });
      if (loaded) {
        onChangeFilter(
          filters,
          search,
          page,
          perPage,
          {
            startDate: d?.startDate,
            endDate: d?.endDate,
          },
          tenancyLockExpiryTracker,
          sort
        );
      }
    }}
  />,
    <DateRangeListFilterWithCustomButton
    placeholder={'Select lock expiry date'}
      default={tenancyLockExpiryTracker}
      onChange={(d?: IDateRange) => {
        setTenancyLockExpiryTracker({
          startDate: d?.startDate,
          endDate: d?.endDate,
        });
        if (loaded) {
          onChangeFilter(
            filters,
            search,
            page,
            perPage,
            {
              startDate: d?.startDate,
              endDate: d?.endDate,
            },
            tenancyLockExpiryTracker,
            sort
          );
        }
      }}
    />,
  ];

  const formatData = (projectData: Project[])=>{
   return  projectData?.map((item:Project)=>({...item, action: {companyId :item.companyId,projectId: item.projectId } }))
  }

  return (
    <AppLayout>
      <>
        <ListHeader additionalRows={[filterRow]} actions={headerActions}>
          <div className="d-flex align-items-center">
            <h2 className="m-0 d-flex align-items-baseline flex-column">
              Tenancy Expiry Tracker
              {data && (
                <span className="font-xs text-muted font-weight-semibold d-block ml-2 pt-2">
                  {data.count} Total
                  <span className="font-weight-normal ml-1">
                    Updated <Moment fromNow date={data.lastUpdatedAt} />
                  </span>
                  {selected.length > 0 && (
                    <span className="font-weight-normal ml-1">
                      Selected {selected.length} items
                    </span>
                  )}
                </span>
              )}
            </h2>
            <div className="view-switch ml-lg-5 ml-md-4 ml-auto pl-3 d-flex">
              <div className="border rounded-sm d-flex font-normal"></div>
            </div>
          </div>
        </ListHeader>
        <>
          {(!loaded || loading) && (
            <ContainerLoader
              height={window.innerHeight - 300}
            ></ContainerLoader>
          )}
          {loaded && !loading && (
            <ListTable
              data={formatData(data?.data)}
              showColumnSettings
              selectedValues={selected}
              // currentCoulumns={
              //   columns?.length
              //     ? columns?.map((item) => item?.props?.column)
              //     : []
              // }
              onSelect={setSelected}
              onSort={(sortKey: string, sortOrder?: SortOrder) => {
                setSort({ sortBy: sortKey, sortOrder });
                onChangeFilter(filters, search, page, perPage, tenancyLeaseExpiryTracker,tenancyLockExpiryTracker,  {
                  sortBy: sortKey,
                  sortOrder,
                });
              }}
              sort={sort}
              // trProps={(d: LeadRequirement) => {
              //   return {
              //     className: classnames({
              //       "cursor-pointer": true,
              //     }),
              //     onClick: () => {
              //       onRequirementClick(d._id);
              //     },
              //   };
              // }}
              onColumnSettingsSaved={saveColumnSettings}
              selectedColumns={leadSettings?.columnSettings?.columns || undefined}
              // onColumnSettingsSaved={(sColumns: Column[]) => setSavedColumns(sColumns)}
            >
              {columnList}
            </ListTable>
          )}
          <Pagination
            currentPage={page}
            totalPages={data?.totalPages}
            onPageChange={(pg: number) => {
              setPage(pg);
              onChangeFilter(filters, search, pg, perPage, tenancyLeaseExpiryTracker,tenancyLockExpiryTracker,  sort);
            }}
            perPage={perPage}
            onPerPageChange={(pg: number) => {
              setPerPage(pg);
              onChangeFilter(filters, search, page, pg, tenancyLeaseExpiryTracker,tenancyLockExpiryTracker,  sort);
            }}
            count={data?.count}
            label="Tenancy Expiry List"
          />
        </>
        {detailModal.isOpen && canViewProject && (
        <RequirementPropertyDetailPage
          onClose={() => setDetailModal({})}
          projectId={detailModal.id}
          showDetailsOnly={true}
        ></RequirementPropertyDetailPage>
      )}
      </>
    </AppLayout>
  );
};

export default TenancyExpiryList;
